import { addClass } from '@/utils/dom';
export default {
    mounted(el, binding) {
        if (el.scrollWidth > el.clientWidth) {
            addClass(el, 'ellipsis');
            el.setAttribute('title', el.innerText);
        }
    },
    beforeUnmount() {
    }
};
